// extracted by mini-css-extract-plugin
export default {"cell":"calling-code-picker_cell__4IlbL","icon":"calling-code-picker_icon__U8Zlm","code":"calling-code-picker_code__04X7E","selected":"calling-code-picker_selected__pS5GG"};